import { TEMPLATE_TYPES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_MailSignatureCreated extends _Event {
    constructor(payload: EventSchema<Template_MailSignatureCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            active: z.boolean().nullish(),
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            name: z.string().min(1),
            priority: z.optional(z.number().int().default(0)),
            type: z.literal(TEMPLATE_TYPES.MAIL_SIGNATURE),
            users: z.array(schemaId),
        });
    }

    static example(): EventSchema<Template_MailSignatureCreated> {
        return {
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            name: 'Mail Template',
            priority: 0,
            type: TEMPLATE_TYPES.MAIL_SIGNATURE,
            users: ['1258ba6a-576e-4dfe-8f82-7c582c4eb082'],
        };
    }
}
